import { useEffect } from 'react';
import { Center } from '@chakra-ui/react';
import { VStack } from 'components/ui';
import { useTracking } from '../../hooks/useTracking';
import { TRACKING_VISITED_LOGIN } from '../OnboardingForm/constants';
import { LoginHeader } from './LoginHeader';
import { LoginForm } from './LoginForm';

export const LoginPage = () => {
  const { page: pageView } = useTracking();

  useEffect(() => {
    pageView(TRACKING_VISITED_LOGIN);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <VStack bg="feather.100" minH="100vh">
      <LoginHeader />
      <Center flex={1} px={4} py={{ base: 10, md: 20 }}>
        <LoginForm />
      </Center>
    </VStack>
  );
};

export default LoginPage;
